import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import moment from "moment";
import { intl } from "LocaleWrapper";
import "chartjs-adapter-moment";

import { ShipEventType } from "__generated__/enums";
import { ShipEventsEventReportsForPeriodFragment } from "__generated__/view/ships/graphql/ship.fragments.generated";

ChartJS.register(...registerables);

const ShipEventsHorizontalBar = ({ timeWindow, reports }: {
	timeWindow: {
		from: number,
		to: number,
	},
	reports: ShipEventsEventReportsForPeriodFragment["reports"]
}) => {
	return (
		<Bar
			key={reports.length}
			height={75 + reports.length * 10}
			data={{
				labels: reports.flatMap(report => report.ship.name),
				datasets: [ {
					label: intl.formatMessage({ id: "TERMINAL" }),
					backgroundColor: "rgb(243, 205, 231)",
					data: reports.flatMap(report => report.events.map(e => ({ ...e, ship: report.ship }))).filter(event => event.type === ShipEventType.LoadDischarge).map(shipEvent => ({
						x: [ moment(shipEvent.start).toDate(), moment(shipEvent.end).toDate() ],
						y: shipEvent.ship.name,
						startTime: moment(shipEvent.start).toDate(),
						endTIme: moment(shipEvent.end).toDate(),
					})),
				}, {
					label: intl.formatMessage({ id: "SHIP_EVENT_RESTING" }),
					backgroundColor: "rgb(204, 66, 83)",
					data: reports.flatMap(report => report.events.map(e => ({ ...e, ship: report.ship }))).filter(event => event.type === ShipEventType.Resting).map(shipEvent => ({
						x: [ moment(shipEvent.start).toDate(), moment(shipEvent.end).toDate() ],
						y: shipEvent.ship.name,
						startTime: moment(shipEvent.start).toDate(),
						endTIme: moment(shipEvent.end).toDate(),
					})),
				}, {
					label: intl.formatMessage({ id: "SHIP_EVENT_SAILING" }),
					backgroundColor: "rgb(40, 156, 55)",
					data: reports.flatMap(report => report.events.map(e => ({ ...e, ship: report.ship }))).filter(event => event.type === ShipEventType.Sailing).map(shipEvent => ({
						x: [ moment(shipEvent.start).toDate(), moment(shipEvent.end).toDate() ],
						y: shipEvent.ship.name,
						startTime: moment(shipEvent.start).toDate(),
						endTIme: moment(shipEvent.end).toDate(),
					})),
				}, {
					label: intl.formatMessage({ id: "SHIP_EVENT_WAITING" }),
					backgroundColor: "rgb(49, 144, 216)",
					data: reports.flatMap(report => report.events.map(e => ({ ...e, ship: report.ship }))).filter(event => event.type === ShipEventType.Waiting).map(shipEvent => ({
						x: [ moment(shipEvent.start).toDate(), moment(shipEvent.end).toDate() ],
						y: shipEvent.ship.name,
						startTime: moment(shipEvent.start).toDate(),
						endTIme: moment(shipEvent.end).toDate(),
					})),
				} ],
			}}
			options={{
				indexAxis: "y" as const,
				scales: {
					x: {
						type: "time",
						time: {
							unit: "day",
							displayFormats: {
								day: "MMM D",
							},
						},
						min: timeWindow.from,
						max: timeWindow.to,
						ticks: {
							autoSkip: false,
						},
					},
					y: {
						grid: {
							display: true,
						},
						stacked: true,
						beginAtZero: true,
						ticks: {
							autoSkip: false,
						},
					},
				},
				plugins: {
					tooltip: {
						callbacks: {
							label: (item) => {
								return [
									item.dataset.label || "",
									`${moment(item.parsed._custom?.start).format("lll")} - ${moment(item.parsed._custom?.end).format("lll")}`,
								];
							},
						},
					},
				},
			}}
		/>
	);
};

export default ShipEventsHorizontalBar;
